import React from 'react';

import Styles from './styles';
import { BazzarvoiceReviews } from '../BazzarvoiceReviews';
import { PopupIcon } from '../PopupIcon';

const ProductReviewLandingView = ({
  // eslint-disable-next-line react/prop-types
  precontent,
  // eslint-disable-next-line react/prop-types
  content,
  // eslint-disable-next-line react/prop-types
  shingleLine,
}) => (
  <div css={Styles}>
    <div id="photo-viewer-modal" />

    <div className="product-review-landing__layout">
      <PopupIcon />

      <BazzarvoiceReviews shingleLine={shingleLine} />

      <div className="product-review-landing__disclaimer">
        *Shingle products may vary by region. Reviews are based on the reviewer’s actual experience with the product and
        reflect the honest beliefs and experiences of the reviewer.
      </div>

      <div className="product-review-landing__black-devider" />
    </div>
  </div>
);

export { ProductReviewLandingView };
